import { render, staticRenderFns } from "./HomelyRemedies.vue?vue&type=template&id=04d7de5a"
import script from "./HomelyRemedies.vue?vue&type=script&lang=js"
export * from "./HomelyRemedies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports